import { Button } from 'primereact/button';
import React from 'react';

export const DeleteButton = ({ onDelete }) => {
  return (
    <Button
      label="삭제"
      icon="pi pi-trash"
      className="p-button-outlined p-button-danger"
      onClick={onDelete}
    />
  );
};
